<div class="wrapper bg-area">
  <section id="faca-parte">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <p>Configure sua assinatura de hotéis do seu jeito. <br *ngIf="isMobile"> Não leva mais do que 3 minutos!</p>
            <app-slide-menu [item]="slideMenu"></app-slide-menu>
        </div>
      </div>
            <form [formGroup]="form" class="form-montreal-plano-home" (ngSubmit)="onSubmit()" *ngIf="form">
                <div class="body-faca-parte columns">
                    <div class="column is-6">
                        <div>
                            <h4 *ngIf="cart.text1"> Plano {{cart.title}}<br></h4>
                            <p *ngIf="cart.text1" [innerHTML]="cart.text1"></p>
                        </div>
                        <div class="area-proposta">
                            <fieldset>
                                <div class="area-field">
                                    <label for="selectedCategory" class="small-label">
                                        <span><i class="fas fa-calendar"></i> Plano</span>
                                        <div class="input-number-area custom-select">
                                            <select id="selectedCategory" formControlName="selectedCategory"
                                                    (change)="onChangeCategoryList()"
                                                    class="select-planos">
                                                <option *ngFor="let item of cart.plans" value="{{item.categoryCode}}">
                                                    {{item.description}}
                                                </option>
                                            </select>
                                        </div>
                                    </label>
                                    <label for="dailyCounter" class="small-label" *ngIf="!isMobile">
                                        <span><i class="fas fa-calendar"></i> Diárias</span>
                                        <div class="input-number-area">
                                            <a class="qty-decrement" (click)="lessDailyList()">–</a>
                                            <input id="dailyCounter" formControlName="dailyCounter" min="{{minDaily}}"
                                                   max="{{maxDaily}}" type="number" name="dailyCounter">
                                            <a class="qty-increment" (click)="moreDailyList()">+</a>
                                        </div>
                                    </label>
                                    <label for="dailyCounterMobile" class="small-label" *ngIf="isMobile">
                                        <span><i class="fas fa-calendar"></i> Diárias</span>
                                        <div class="input-number-area custom-select">
                                            <select id="dailyCounterMobile" formControlName="dailyCounter" (change)="onChangeLessDailyList()"
                                                    class="select-diarias">
                                                <option *ngFor="let item of mobileDiaries(cart)" value="{{item.value}}">
                                                    {{item.value}}
                                                </option>
                                            </select>
                                        </div>
                                    </label>
                                    <label for="selectedTypeValue" class="small-label">
                                        <span><i class="fas fa-bed"></i> Quartos</span>
                                        <div class="input-number-area custom-select">
                                            <select id="selectedTypeValue" formControlName="selectedTypeValue" (change)="onChangeTypeList()"
                                                    class="select-quarto">
                                                <option [value]="i.value" *ngFor="let i of typeValues">{{i.label}}</option>
                                            </select>
                                        </div>
                                    </label>
                                </div>
                            </fieldset>
                            <div class="valor-total valor-total__unico" >
                                Total: <span class="valor-total__item">{{cart.formattedMonthlyValue}} </span><span class="valor-total__sub"> / mês</span>
                            </div>
                            <div class="personal-data">
                                <h4 class="personal-data__title">Faça o seu cadastro e siga para a próxima etapa.</h4>
                                <fieldset>
                                    <div class="area-field">
                                        <label for="name">
                                            <input id="name"
                                                   type="text"
                                                   [class]="fieldCssClass(form, 'name')"
                                                   required
                                                   placeholder="Nome Completo"
                                                   formControlName="name">
                                            <span *ngIf="showError('name')" class="campo-erro">
                                                {{getErrorMessage('name')}}
                                            </span>
                                        </label>
                                        <label for="mobile">
                                            <input id="mobile"
                                                   mask="(00) 00000-0000"
                                                   type="tel"
                                                   [class]="fieldCssClass(form, 'mobile')"
                                                   required
                                                   placeholder="Celular"
                                                   mask-output="alphanumeric"
                                                   formControlName="mobile">
                                            <span *ngIf="showError('mobile')" class="campo-erro">
                                                {{getErrorMessage('mobile')}}
                                            </span>
                                        </label>
                                        <label for="email">
                                            <input id="email"
                                                   type="text"
                                                   [class]="fieldCssClass(form, 'email')"
                                                   required
                                                   placeholder="E-mail"
                                                   formControlName="email">
                                            <span *ngIf="showError('email')" class="campo-erro" >
                                                {{getErrorMessage('email')}}
                                            </span>
                                        </label>
                                    </div>
                                </fieldset>
                            </div>
                            <div style="padding-top: 1.2em;">
                                <app-termo-uso [type]="'faca-parte'"
                                               [link]="'/politica-privacidade'"
                                               (termoDeUsoAceitoEmit)="termsOfUseAcceptedEmit($event)"></app-termo-uso>
                            </div>
                            <div class="btn-mobile" *ngIf="isMobile">
                                <button type="submit"
                                        [disabled]="!isFormValid()"
                                        [class]="!isFormValid() ? 'btn-desabilitado' : 'btn-verde'"
                                        class="btn-verde">CADASTRAR AGORA
                                </button>
                            </div>
                            <button *ngIf="!isMobile"
                                    type="submit"
                                    [disabled]="!isFormValid()"
                                    [class]="!isFormValid() ? 'btn-desabilitado' : 'btn-verde'"
                                    class="btn-verde">CADASTRAR AGORA
                            </button>

                        </div>
                    </div>
                    <app-resumo [result]="propostaResult" [totalDiarias]="countDiarias" (carrinhosChange)="onCartChange($event)">

                    </app-resumo>
                </div>
            </form>
        </div>
    </section>
</div>
